var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0955 14.2649L25.9232 4.54048C26.3979 4.07181 27.1681 4.07181 27.6427 4.54048C28.1174 5.01032 28.1174 5.77155 27.6427 6.24022L17.6843 16.0951L27.644 25.9499C28.1187 26.4186 28.1187 27.1798 27.644 27.6485C27.1681 28.1172 26.399 28.1172 25.9244 27.6485L15.9045 17.7338L6.07564 27.4595C5.60095 27.9282 4.83194 27.9282 4.35601 27.4595C3.88133 26.9909 3.88133 26.2296 4.35601 25.761L14.3157 15.9061L4.35726 6.05125C3.88257 5.58257 3.88257 4.82135 4.35726 4.3515C4.83194 3.88283 5.60207 3.88283 6.07676 4.3515L16.0955 14.2649Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8536a37bbdd894163598bb80eef2a627.svg";
export { ForwardRef as ReactComponent };